import { render, staticRenderFns } from "./serviceinfo.vue?vue&type=template&id=a1cf0f5a&scoped=true&"
import script from "./serviceinfo.vue?vue&type=script&lang=js&"
export * from "./serviceinfo.vue?vue&type=script&lang=js&"
import style0 from "./serviceinfo.vue?vue&type=style&index=0&id=a1cf0f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cf0f5a",
  null
  
)

export default component.exports